// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__0QE_M","chatIcon":"styles_chatIcon__MxsjU","version":"styles_version__en7XY","link":"styles_link__weRO_"};